// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f09dc7d3","239":"74ff56ca","455":"204a77ff"}[chunkId] + ".chunk.js";
};